module.exports = __webpack_public_path__ + "bd.svg?6fa55e57b26bd046ad9edbfef28c4c92";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bd.svg
// module id = 1194
// module chunks = 27